module.exports = "/fonts/Roboto-Medium.ttf?b2bcaa52d04bde9a494fd954ef7e7e7b";